module.exports = __webpack_public_path__ + "MapStore2/web/client/plugins/background/assets/img/s2cloudless.jpg";